import React, { useState } from 'react';
import { Box } from '@mui/material';
import { Inventory2Outlined as ProductIcon } from '@mui/icons-material';

// Imagen cuadrada con fallback si no hay foto o falla la carga.
const ProductImage = ({ src, alt, sx }) => {
    const [failed, setFailed] = useState(false);

    return (
        <Box
            sx={{
                position: 'relative',
                width: '100%',
                paddingTop: '100%',
                backgroundColor: '#13233A',
                overflow: 'hidden',
                ...sx,
            }}
        >
            {src && !failed ? (
                <Box
                    component="img"
                    src={src}
                    alt={alt}
                    loading="lazy"
                    onError={() => setFailed(true)}
                    sx={{
                        position: 'absolute',
                        inset: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        display: 'block',
                    }}
                />
            ) : (
                <Box
                    sx={{
                        position: 'absolute',
                        inset: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <ProductIcon sx={{ fontSize: 40, color: '#444' }} />
                </Box>
            )}
        </Box>
    );
};

export default ProductImage;
